import moment from 'moment'
import React, { useState } from 'react'
import { Icon, Loader } from '../../styles/components'
import { TimeLine, TimeLineItem, TimeLineMore, Modal } from './styles'

const VISIBLE_COUNT = 5

function Timeline({ data, comprovante }) {
    const [showAll, setShowAll] = useState(false)
    const [showComprovante, setShowComprovante] = useState(false)
    const [comprovanteImage, setComprovanteImage] = useState(null)
    const [loadingComprovante, setLoadingComprovante] = useState(false)

    const hasComprovante = Boolean(
        comprovante?.img_url ||
            comprovante?.nome_recebedor ||
            comprovante?.doc_recebedor ||
            comprovante?.info_recebedor
    )

    async function handleOpenComprovante() {
        setShowComprovante(true)
        if (!comprovante?.img_url) return
        setLoadingComprovante(true)
        try {
            const res = await fetch(comprovante.img_url)
            if (!res.ok) throw new Error('Falha ao buscar comprovante')
            const blob = await res.blob()
            setComprovanteImage(URL.createObjectURL(blob))
        } catch (err) {
            console.error('Erro ao carregar comprovante de entrega', err)
        } finally {
            setLoadingComprovante(false)
        }
    }

    function handleCloseComprovante() {
        if (comprovanteImage) {
            URL.revokeObjectURL(comprovanteImage)
        }
        setComprovanteImage(null)
        setShowComprovante(false)
    }

    const sortedData = [...data].sort((a, b) => {
        if (a?.priority > b?.priority) {
            return 1
        }
        if (a?.priority < b?.priority) {
            return -1
        }
        return 0
    })

    const hasMore = sortedData.length > VISIBLE_COUNT + 1
    const visibleData =
        showAll || !hasMore
            ? sortedData
            : [
                  ...sortedData.slice(0, VISIBLE_COUNT),
                  sortedData[sortedData.length - 1],
              ]

    return (
        <>
            <TimeLine>
                {visibleData.map((item, key) => (
                    <React.Fragment key={item._id}>
                        <TimeLineItem
                            items={visibleData?.length}
                            className="timeline-item"
                            color={item?.tracking_event?.color || '#bc32ac'}
                            active={true}
                            before={key !== visibleData.length - 1}
                            onClick={
                                item?.status_keyname === 'entregue' &&
                                hasComprovante
                                    ? handleOpenComprovante
                                    : undefined
                            }
                            style={
                                item?.status_keyname === 'entregue' &&
                                hasComprovante
                                    ? { cursor: 'pointer' }
                                    : undefined
                            }
                        >
                            <div className="icon shrink-0">
                                <Icon
                                    icon={(
                                        item?.tracking_event?.icon || 'fas info'
                                    )?.split(' ')}
                                />
                            </div>
                            <div className="flex flex-col w-full">
                                <div className="flex items-center justify-between flex-1">
                                    <div className="flex gap-2 items-center">
                                        <span className="font-semibold text-black text-left text-sm">
                                            {item?.tracking_event?.message ||
                                                item?.tracking_event?.name ||
                                                '-'}
                                        </span>
                                    </div>
                                    <div className="flex gap-2 items-center">
                                        <span className="whitespace-nowrap">
                                            {moment(item?.__created).format(
                                                'DD/MM HH:mm'
                                            )}
                                        </span>
                                    </div>
                                </div>
                                {item?.status_keyname === 'entregue' &&
                                    hasComprovante && (
                                        <span
                                            className="text-left text-xs -mt-0.5"
                                            style={{
                                                color: 'var(--blue)',
                                                fontWeight: 700,
                                            }}
                                        >
                                            Informações do recebedor
                                        </span>
                                    )}
                                {item?.carrier_node && (
                                    <span className="text-left text-xs -mt-0.5">
                                        {item?.carrier_node}
                                    </span>
                                )}
                                {item?.prazo_entrega && (
                                    <span className="text-left text-xs -mt-0.5">
                                        {item?.prazo_entrega}
                                    </span>
                                )}
                            </div>
                        </TimeLineItem>
                        {!showAll && hasMore && key === VISIBLE_COUNT - 1 && (
                            <div
                                className="mb-5 text-black cursor-pointer"
                                color="white"
                                size="small"
                                onClick={() => setShowAll(true)}
                            >
                                Ver mais detalhes
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </TimeLine>
            {showComprovante && (
                <Modal>
                    <div
                        style={{
                            position: 'relative',
                            zIndex: 999,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 8,
                            maxWidth: '85%',
                            maxHeight: '90%',
                        }}
                    >
                        <button
                            type="button"
                            onClick={handleCloseComprovante}
                            aria-label="Fechar"
                            style={{
                                position: 'absolute',
                                top: -14,
                                right: -14,
                                width: 28,
                                height: 28,
                                borderRadius: '50%',
                                border: 'none',
                                background: 'white',
                                color: 'var(--dark)',
                                fontSize: 16,
                                lineHeight: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                            }}
                        >
                            ×
                        </button>
                        {loadingComprovante ? (
                            <Loader />
                        ) : comprovanteImage ? (
                            <img
                                src={comprovanteImage}
                                alt="Comprovante de entrega"
                            />
                        ) : null}
                        {(comprovante?.nome_recebedor ||
                            comprovante?.doc_recebedor ||
                            comprovante?.info_recebedor) && (
                            <div
                                style={{
                                    color: 'white',
                                    textAlign: 'center',
                                }}
                            >
                                <strong
                                    style={{
                                        display: 'block',
                                        fontSize: 14,
                                        marginBottom: 4,
                                    }}
                                >
                                    Informações do recebedor
                                </strong>
                                {comprovante?.nome_recebedor && (
                                    <span
                                        style={{
                                            display: 'block',
                                            fontSize: 13,
                                        }}
                                    >
                                        {comprovante.nome_recebedor}
                                    </span>
                                )}
                                {comprovante?.doc_recebedor && (
                                    <span
                                        style={{
                                            display: 'block',
                                            fontSize: 13,
                                        }}
                                    >
                                        Doc: {comprovante.doc_recebedor}
                                    </span>
                                )}
                                {comprovante?.info_recebedor && (
                                    <span
                                        style={{
                                            display: 'block',
                                            fontSize: 13,
                                        }}
                                    >
                                        {comprovante.info_recebedor}
                                    </span>
                                )}
                            </div>
                        )}
                    </div>
                    <div className="overlay" onClick={handleCloseComprovante} />
                </Modal>
            )}
        </>
    )
}

export default Timeline
